/**
 * Enhanced error message utility for user-friendly error messages
 */

export function getErrorMessage(error) {
  const errorCode = error.code || error.message;

  switch (errorCode) {
    case 'auth/email-already-in-use':
      return 'An account with this email already exists.';
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/weak-password':
      return 'Password should be at least 6 characters long.';
    case 'auth/network-request-failed':
      return 'Network error. Please check your connection and try again.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please try again later.';
    case 'auth/user-not-found':
      return 'User account not found.';
    case 'auth/wrong-password':
      return 'Incorrect password.';
    case 'auth/user-disabled':
      return 'This account has been disabled.';
    case 'auth/operation-not-allowed':
      return 'This operation is not allowed.';
    case 'auth/invalid-credential':
      return 'Invalid credentials provided.';
    case 'auth/account-exists-with-different-credential':
      return 'An account already exists with the same email but different sign-in credentials.';
    case 'auth/requires-recent-login':
      return 'This operation requires recent authentication. Please log in again.';
    case 'auth/provider-already-linked':
      return 'This provider is already linked to your account.';
    case 'auth/no-such-provider':
      return 'No such provider is linked to your account.';
    case 'auth/invalid-verification-code':
      return 'Invalid verification code.';
    case 'auth/invalid-verification-id':
      return 'Invalid verification ID.';
    case 'auth/missing-verification-code':
      return 'Missing verification code.';
    case 'auth/missing-verification-id':
      return 'Missing verification ID.';
    case 'auth/quota-exceeded':
      return 'Service quota exceeded. Please try again later.';
    case 'auth/unavailable':
      return 'Service is currently unavailable. Please try again later.';
    case 'auth/internal-error':
      return 'An internal error occurred. Please try again.';
    default:
      return 'Account creation failed. Please try again.';
  }
}

export function logError(context, error, additionalData = {}) {
  console.error(`[${context}] Error:`, {
    message: error.message,
    code: error.code,
    stack: error.stack,
    timestamp: new Date().toISOString(),
    ...additionalData,
  });
}
